/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent, useState } from 'react';

import { PrimaryButton } from '@components/library/button';
import { LabelPosition, StandardSwitch } from '@components/library/switch';
import { getAiSearch, semanticSearchFeature, setAiSearch } from '@helpers/semantic_search';

import './styles/ai-search-banner.scss';

const AiSearchBanner: FunctionComponent = () => {
  const [state, setState] = useState(getAiSearch());
  // Hide for share manifest / download request viewers — no user account to persist toggle
  if (typeof window !== 'undefined' && (window as any).BFG?.showPageLite) return null;
  if (!semanticSearchFeature()) return null;

  const update = (patch: { accepted?: boolean; enabled?: boolean }): void => {
    const next = { ...state, ...patch };
    setAiSearch(patch);
    setState(next);
    if (patch.enabled !== undefined) {
      if (!next.enabled) {
        window.location.href = window.location.pathname;
      } else {
        window.location.reload();
      }
    }
  };

  if (!state.accepted) {
    return (
      <div
        aria-label="AI Search early adopter"
        className="ai-search-banner ai-search-banner--welcome"
        role="region"
      >
        <div aria-hidden="true" className="ai-search-banner__icon">
          <span className="bff-lightbulb-filled" />
        </div>
        <div className="ai-search-banner__content">
          <h3 className="ai-search-banner__title">
            Welcome to the Early Adopter Program
          </h3>
          <p className="ai-search-banner__description">
            Your admin enrolled you in EAP. Introducing, AI Search. Skip the
            exact keywords, just ask. Type a few words or a full question like
            &quot;espresso pulls approved by Jason&quot; and get results ranked
            by meaning, with autocomplete and visual similarity. Switch back to
            Legacy Search anytime and nothing you&apos;ve built is affected.
          </p>
          <PrimaryButton
            className="ai-search-banner__cta"
            onClick={() => update({ accepted: true, enabled: true })}
            size="small"
          >
            Enable AI Search
          </PrimaryButton>
        </div>
      </div>
    );
  }

  return (
    <div
      aria-label="AI Search"
      className={`ai-search-banner ai-search-banner--mini ${state.enabled ? '' : 'ai-search-banner--disabled'}`}
      role="region"
    >
      <div aria-hidden="true" className="ai-search-banner__icon">
        <span className="bff-lightbulb-filled" />
      </div>
      <div className="ai-search-banner__content">
        <h3 className="ai-search-banner__title">
          <span className="ai-search-banner__status-label">{'AI Search is toggled '}</span>
          <span className={`ai-search-banner__status-value${state.enabled ? ' ai-search-banner__status--on' : ''}`}>
            {state.enabled ? 'ON' : 'OFF'}
          </span>
        </h3>
      </div>
      <StandardSwitch
        className="ai-search-banner__switch"
        isChecked={state.enabled}
        labelPosition={LabelPosition.Right}
        onChange={() => update({ enabled: !state.enabled })}
      >
        {''}
      </StandardSwitch>
    </div>
  );
};

export default AiSearchBanner;
